import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root/root-types';

export const CONFIG_FEATURE_KEY = 'configData';

export interface AgentTaskSetting {
  id: string;
  enabled: boolean;
}

export interface AgentSettingsState {
  id: string;
  workspaceId: string;
  isBotEnabled: boolean;
  isAgentEnabled: boolean;
  muteOutOfScopeResponse: boolean;
  createdAt: string;
  updatedAt: string;
  tasks: AgentTaskSetting[];
}

export interface ConfigState {
  isSideDrawerOpen: boolean;
  hasFetchedAgentSettings: boolean;
  agentSettings: AgentSettingsState | null;
}

export const initialConfigState: ConfigState = {
  isSideDrawerOpen: false,
  hasFetchedAgentSettings: false,
  agentSettings: null,
};

export const configSlice = createSlice({
  name: CONFIG_FEATURE_KEY,
  initialState: initialConfigState,
  reducers: {
    updateIsSideDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isSideDrawerOpen = action.payload;
    },
    updateHasFetchedAgentSettings: (state, action: PayloadAction<boolean>) => {
      state.hasFetchedAgentSettings = action.payload;
    },
    updateAgentSettings: (
      state,
      action: PayloadAction<AgentSettingsState | null>
    ) => {
      state.agentSettings = action.payload;
    },
  },
});

export const {
  updateIsSideDrawerOpen,
  updateHasFetchedAgentSettings,
  updateAgentSettings,
} = configSlice.actions;

export const getConfigSliceState = (rootState: RootState): ConfigState =>
  rootState[CONFIG_FEATURE_KEY];

export const getIsSideDrawerOpen = createSelector(
  getConfigSliceState,
  (state) => state.isSideDrawerOpen
);

export const getAgentSettings = createSelector(
  getConfigSliceState,
  (state) => state.agentSettings
);

export const getHasFetchedAgentSettings = createSelector(
  getConfigSliceState,
  (state) => state.hasFetchedAgentSettings
);

export const getIsOrderTaskEnabled = createSelector(
  getAgentSettings,
  (agentSettings) => {
    const orderTask = agentSettings?.tasks?.find((task) => task.id === 'order');
    return orderTask ? orderTask.enabled : true;
  }
);
